/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig';

export class HighFrequencyBackupSchedules {
  /**
  * Vault ID.
  */
  'vaultId': string;
  'scheduleConfig': HighFrequencyBackupScheduleConfig;
  /**
  * Backup retention period, in days.
  */
  'backupRetentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "scheduleConfig",
      "baseName": "scheduleConfig",
      "type": "HighFrequencyBackupScheduleConfig",
      "format": ""
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return HighFrequencyBackupSchedules.attributeTypeMap;
  }

  public constructor() {
  }
}

